module.exports = __webpack_public_path__ + "img/location.acfc1d12.png";